var cancellationSummaryTemplate = require('templates/cancellationSummary.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
  type: 'cancellationSummary',
  template: {
    'cancellationSummary': cancellationSummaryTemplate
  },
  subscribe: {
    'CANCEL_RESERVATION_CHECKBOX_VAL': 'redemptionDetailsChange'
  },
  bindEvents: function () {
    var _self = this;
    _self.redemptionRoomChange();
    _self.redemptionCertificateChange();
  },

  /**
   * This method modifies the messages based on the chckboxes checked
   * @param {Object} checkedCheckboxes checkboxes selected where check/uncheck happens
   * @return {boolean} Operation succeeded or not
   */
  redemptionDetailsChange: function _redemptionDetailsChange(checkedCheckboxes){
    var _self = this;
    _self.updatePointCertificateContainer(checkedCheckboxes);
    _self.redemptionRoomChange();
    _self.redemptionCertificateChange();
    _self.updateRoomPoints();
    return true;
  },

  /**
   * This method modifies the messages based on the checkboxes checked
   * @param {Object} checkedCheckboxes checkboxes selected where check/uncheck happens
   * @return {boolean} Operation sucess/failure
   */
  updatePointCertificateContainer: function _updatePointCertificateContainer(checkedCheckboxes){
    var _self = this,
        containerType = [_self.$el.find('.l-room-points'),_self.$el.find('.js-certificate-information')];
        containerType.forEach(function(value, index){
          $(value).each(function() {
             $(this).addClass('is-hidden');
          });
        });
        checkedCheckboxes.each(function(index, value){
          _self.$el.find('[data-confirmation-number="' + this.value + '"]').each(function(){
            $(this).removeClass('is-hidden');
          });
        });
    return true;
  },

  /**
   * This method modifies the points labels on multiple rooms selection
   * @return {boolean} Operation success/failure   
   */
  redemptionRoomChange: function _redemptionRoomChange(){
    this.$el.find('.js-room-points-container').toggleClass('is-hidden', this.$el.find('.l-room-points').not('.is-hidden').length < 2);
    return true;
  },

  /**
   * This method modifies the certificate message containers on checkbox selection
   * @return {boolean} Operation success/failure
   */
  redemptionCertificateChange: function _redemptionCertificateChange(){
    var _self = this,
        validCertificateContainerCount = _self.$el.find('.js-certificate-information').not('.is-hidden').length;
    _self.$el.find('.t-room-index').toggleClass('is-hidden', validCertificateContainerCount < 2);
    _self.$el.find('.js-room-label').toggleClass('is-hidden', validCertificateContainerCount < 2).next().toggleClass('l-padding-left-none', validCertificateContainerCount < 2);
    _self.$el.find('.l-certificate-container').toggleClass('is-hidden', validCertificateContainerCount < 1);
    return true;
  },

  /**
   * This method modifies the total number of points for the rooms
   * @return {boolean} Operation success/failure   
   */
  updateRoomPoints: function _updateRoomPoints(){
    var _self = this,
       totalPoints = 0;
    _self.$el.find('.l-room-points').not('.is-hidden').each(function(){
      totalPoints += Number($(this).data('room-points'));
    });
    _self.$el.find('.js-total-room-points').html(totalPoints.toLocaleString());
    return true;
  }
});
